'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartBarOutline = function TiChartBarOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 8.3c-1.3 0-2.4 0.5-3.3 1.3v-2.9c0-2.8-2.2-5-5-5s-5 2.2-5 5v7.9c-0.9-0.8-2-1.3-3.3-1.3-2.8 0-5 2.3-5 5v10h26.6v-15c0-2.7-2.2-5-5-5z m-8.3-3.3c0.9 0 1.7 0.7 1.7 1.7v18.3h-3.4v-18.3c0-1 0.8-1.7 1.7-1.7z m-6.7 20h-3.3v-6.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6v6.7z m16.7 0h-3.3v-11.7c0-0.9 0.7-1.6 1.6-1.6s1.7 0.7 1.7 1.6v11.7z m1.7 10h-23.4c-0.9 0-1.6-0.7-1.6-1.7s0.7-1.6 1.6-1.6h23.4c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7z' })
        )
    );
};

exports.default = TiChartBarOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-bar-outline.js
// module id = 2004
// module chunks = 0